import { DetailsHeader } from 'office-ui-fabric-react/lib/components/DetailsList/DetailsHeader';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import React, { Component } from 'react';
import Scriba from 'react-scriba';

export class SyntheseAppelsDeFonds extends Component {

    static defaultProps = {
        items: [],
        itemsSelectionnes: [],
    };

    static defaultState = {
    };

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this.state = { ...SyntheseAppelsDeFonds.defaultState };
    };

    _calculateRowData = (items) => {
        let actes = 0;
        let appeles = 0;
        let dus = 0;
        let exigibles = 0;
        let nbLots = 0;
        let nbLotsActes = 0;

        items.forEach(item => {
            const { dateSignatureActe, montantTotalTTCAppele, montantTotalTTCDu, montantTotalTTCExigible, prixVenteTTC } = item;

            nbLots++;
            if (!!dateSignatureActe) {
                nbLotsActes++;
                if (!!prixVenteTTC) actes += prixVenteTTC;
            }
            if (!!montantTotalTTCExigible) exigibles += montantTotalTTCExigible;
            if (!!montantTotalTTCAppele) appeles += montantTotalTTCAppele;
            if (!!montantTotalTTCDu) dus += montantTotalTTCDu;
        });

        return { dus, actes, appeles, exigibles, nbLots, nbLotsActes };
    };

    _getColumns = () => {
        const styles = { display: "block", textAlign: "right" };
        return [
            {
                fieldName: "rowTitle",
                key: "rowTitle",
                name: "",
            },
            {
                key: "nbLots",
                name: "Nb lots",
                onRender: (item) => <span style={styles}>{item.nbLots}</span>
            },
            {
                key: "nbLotsActes",
                name: "Nb lots actés",
                onRender: (item) => <span style={styles}>{item.nbLotsActes}</span>
            },
            {
                key: "actes",
                name: "Actés",
                onRender: (item) => <span style={styles}>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.actes.toFixed(2), false, 2)}&nbsp;€</span>
            },
            {
                key: "exigibles",
                name: "Exigibles",
                onRender: (item) => <span style={styles}>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.exigibles.toFixed(2), false, 2)}&nbsp;€</span>
            },
            {
                key: "appeles",
                name: "Appelés",
                onRender: (item) => <span style={styles}>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.appeles.toFixed(2), false, 2)}&nbsp;€</span>
            },
            {
                key: "dus",
                name: "Dus",
                onRender: (item) => <span style={styles}>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.dus.toFixed(2), false, 2)}&nbsp;€</span>
            }
        ];
    };

    render = () => {

        const { items, itemsSelectionnes } = this.props;

        const totalSelection = this._calculateRowData(itemsSelectionnes);
        const total = this._calculateRowData(items);

        const rows = [
            { ...totalSelection, rowTitle: "TOTAL lignes sélectionnées" },
            { ...total, rowTitle: "TOTAL tableau" },
        ];

        return <DetailsList
            columns={this._columns}
            items={rows}
            onRenderDetailsHeader={(props, defaultRender) => defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: tooltipHostProps => <span style={{ display: "flex", justifyContent: "end" }}>{tooltipHostProps.children}</span>
            })}
            selectionMode={SelectionMode.none}
        />;

    };

};